export default {
  id: null,
  email: null,
  fullname: null,
  phone_number: null,
  work_in: null,
  role: null,
  status: null,
  signup: null,
  activated: null,
  last_login: null,
  credits: null,
  keywords_count: 0,
  projects_count: 0,
  reports_count: 0,
  links_count: 0,
  permissions: null,
  overridden_permissions: null,
  projects: null,
  first_day_of_week: 0,
  currency: 1,
  active_plan: 'smb',
  ip_data: null,
  package_id: 0,
  package_expired_at: '',
  keywords_limit: 0,
  projects_limit: 0,
  links_limit: 0,
  reports_limit: 0,
  keywords_count_limit: 0,
  projects_count_limit: 0,
  links_count_limit: 0,
  reports_count_limit: 0,
  limits: null,
  extra_limits: null,
  history_starts_at: '',
  package_status: null,
  made_reports: 0,
  coupon: null,
  is_affiliate: null,
  // is_ten_club_member: false,
  ten_club_reports: [],
  subscription_renew: false,
  package_display_name: '',
  finished_steps: [],
  package_level: 0,
  country_code: '',
  affiliate_name: '',
  workspaces_count: 0,
  workspaces_limit: 0,
  competitors_workspaces_count: 0,
  competitors_workspaces_limit: 0,
  urls_traffic_count: 0,
  urls_traffic_limit: 0,
  global_reports_count: 0,
  global_reports_limit: 0,
  made_global_reports: 0,
  user_type: null,
  events: [],
  statuses: {
    NotVerified: 0,
    EmailOnlyVerified: 1,
    PhoneOnlyVerified: 2,
    EmailAndPhoneVerified: 3,
    AlternativeVerified: 4,
    Deleted: 100,
    Blocked: 101,
    NameAndPassword: 10,
    PhoneUnconfirmed: 11
  },
  statusesSelect: [
    { text: 'Not verified', value: 0, shortText: 'NF' },
    { text: 'Email verified', value: 1, shortText: 'EV' },
    { text: 'Phone verified', value: 2, shortText: 'PV' },
    { text: 'Verified', value: 3, shortText: 'V' },
    { text: 'Alternative', value: 4, shortText: 'Alt' },
    { text: 'Deleted', value: 100, shortText: 'D' },
    { text: 'Blocked', value: 101, shortText: 'B' },
    { text: 'NameAndPassword', value: 10, shortText: 'NP' },
    { text: 'PhoneUnconfirmed', value: 11, shortText: 'PhU' },
    { text: 'New test asd', value: 12, shortText: 'PhU' }
  ],
  statusesData: {
    0: {
      text: 'Not verified',
      color: ''
    },
    1: {
      text: 'Email verified',
      color: 'teal accent-4'
    },
    2: {
      text: 'Phone verified',
      color: 'teal accent-4'
    },
    3: {
      text: 'Verified',
      color: 'green'
    },
    4: {
      text: 'Alternative',
      color: 'purple'
    },
    100: {
      text: 'Deleted',
      color: 'grey'
    },
    101: {
      text: 'Blocked',
      color: 'red'
    },
    10: {
      text: 'Name And Password verified',
      color: 'cyan'
    },
    11: {
      text: 'Phone Unconfirmed',
      color: 'warning'
    },
    12: {
      text: 'New test asd',
      color: 'warning'
    }
  },
  types: {
    REGULAR: 0,
    FOLLOW_UP: 1,
    WEBINAR: 2,
    HANGOUTS: 3,
    LIVE: 4,
    LIVE_OFFER: 5,
    ROGER_FLOW: 6,
    BIGGER: 7
  },
  typesData: {
    0: { text: 'Regular', color: 'grey' },
    1: { text: 'Analyze Domain', color: 'cyan' },
    2: { text: 'Webinar', color: 'teal' },
    3: { text: 'Hangouts', color: 'lime' },
    4: { text: 'Live', color: 'purple' },
    5: { text: 'Live Offer', color: 'indigo' },
    6: { text: 'Roger Flow', color: 'indigo' },
    7: { text: 'Bigger Flow', color: 'yellow' }
  },
  is_trial_available: null,
  is_trial: null,
  package_type: null,
  webinarFollowUpText: '',
  webinarFollowUpCookieName: 'webinar_follow_up_text_1',
  adminReminderText: '',
  reminderText: '',
  remindersCount: 0,
  adminReminderCookieName: 'admin_reminder_text_1',
  reminderCookieName: 'admin_reminder_text_1',
  newFlowCookieName: 'new_flow_domain_1',
  newFlowDomain: null,
  workInList: [
    'Agency',
    'Freelance',
    'In-house SEO',
    'Site owner',
    'Other'
  ],
  notesTypes: {
    DEFAULT: 0,
    REMINDER: 1,
    REMINDER_ACTIVE: 2,
    REMINDER_TODAY: 3
  },
  notesTypesData: {
    0: { text: 'Default', color: 'grey', shortText: 'Def' },
    1: { text: 'Reminder', color: 'cyan', shortText: 'Rem' },
    2: { text: 'Active', color: 'green', shortText: 'Ac' },
    3: { text: 'Today', color: 'red', shortText: 'To' }
  },
  notesTypesSelect: [
    { text: 'Default', value: 0 },
    { text: 'Reminder', value: 1 }
  ]
}



// WEBPACK FOOTER //
// ./src/store/user/state.js